import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { Card } from "react-bootstrap";
import { getConfigWithToken } from "../config/config";
import styles from './SessionHistoryDetailView.module.css';

const SECTION_TOGGLE_EVENT = "session-detail-view-expand";

const SessionDetailedViewPage = ({ sessionFormData: propSessionFormData, session: propSession, addendumData: propAddendumData, disableToggle = false }) => {
    const location = useLocation();
    const user = useSelector((state) => state?.user);
    const { session: locationSession } = location.state || {};

    // Use props if provided, otherwise use location state
    const session = propSession || locationSession;

    const [sessionFormData, setSessionFormData] = useState(propSessionFormData ? {
        ...propSessionFormData,
        wasClientAtHome: propSessionFormData.wasClientAtHome || "",
        signedAt: propSessionFormData.signedAt || null
    } : {});
    const [loading, setLoading] = useState(false);
    const [expandedSections, setExpandedSections] = useState(() => []);
    const [addendumData, setAddendumData] = useState(propAddendumData || []);

    // Fetch session history detail data
    useEffect(() => {
        const fetchSessionHistoryDetail = async () => {
            if (!session?._id) return;

            try {
                setLoading(true);
                const response = await axios.get(
                    `${process.env.REACT_APP_BASE_URL}/sessionHistory/get-by-session/${session._id}`,
                    getConfigWithToken(user?.user?.token)
                );
                console.log(response, "responseexistingData")

                if (response.data.success && response.data.data) {
                    const existingData = response.data.data;
                    console.log(existingData, "existingData")
                    setSessionFormData({
                        reasonForSeekingServices: existingData.reasonForSeekingServices || "",
                        selectedConcerns: existingData.selectedConcerns || [],
                        otherConcernText: existingData.otherConcernText || "",
                        duration: existingData.duration || "",
                        totalDuration: existingData.totalDuration || "",
                        frequency: existingData.frequency || "",
                        severity: existingData.severity || "",
                        freeTextHistory: existingData.freeTextHistory || "",
                        selectedMedicalConditions: (existingData.selectedMedicalConditions && Array.isArray(existingData.selectedMedicalConditions) && existingData.selectedMedicalConditions.length > 0) ? existingData.selectedMedicalConditions : [],
                        otherMedicalConditionText: existingData.otherMedicalConditionText || "",
                        selectedPastPsychiatric: (existingData.selectedPastPsychiatric && Array.isArray(existingData.selectedPastPsychiatric) && existingData.selectedPastPsychiatric.length > 0) ? existingData.selectedPastPsychiatric : [],
                        otherPastPsychiatricText: existingData.otherPastPsychiatricText || "",
                        currentMedications: existingData.currentMedications || "",
                        selectedFamilyPsychiatric: (existingData.selectedFamilyPsychiatric && Array.isArray(existingData.selectedFamilyPsychiatric) && existingData.selectedFamilyPsychiatric.length > 0) ? existingData.selectedFamilyPsychiatric : [],
                        otherFamilyPsychiatricText: existingData.otherFamilyPsychiatricText || "",
                        alcohol: existingData.alcohol || "",
                        alcoholDetails: existingData.alcoholDetails || "",
                        cannabis: existingData.cannabis || "",
                        cannabisDetails: existingData.cannabisDetails || "",
                        tobacco: existingData.tobacco || "",
                        tobaccoDetails: existingData.tobaccoDetails || "",
                        illicitDrugs: existingData.illicitDrugs || "",
                        illicitDrugsDetails: existingData.illicitDrugsDetails || "",
                        substanceUseDetails: existingData.substanceUseDetails || "",
                        livingSituation: existingData.livingSituation || "",
                        selectedSupportSystem: existingData.selectedSupportSystem || [],
                        otherSupportSystemText: existingData.otherSupportSystemText || "",
                        familySocialNotes: existingData.familySocialNotes || "",
                        highestEducationLevel: existingData.highestEducationLevel || "",
                        otherEducationLevelText: existingData.otherEducationLevelText || "",
                        employmentStatus: existingData.employmentStatus || "",
                        otherEmploymentStatusText: existingData.otherEmploymentStatusText || "",
                        currentJobRole: existingData.currentJobRole || "",
                        appearance: existingData.appearance || "",
                        behavior: existingData.behavior || "",
                        speech: existingData.speech || "",
                        mood: existingData.mood || "",
                        affect: existingData.affect || "",
                        thoughtProcess: existingData.thoughtProcess || "",
                        orientation: existingData.orientation || "",
                        insightJudgment: existingData.insightJudgment || "",
                        suicideRisk: existingData.suicideRisk || "",
                        homicideRisk: existingData.homicideRisk || "",
                        abuseNeglect: existingData.abuseNeglect || "",
                        safetyPlanNotes: existingData.safetyPlanNotes || "",
                        selectedStrengths: existingData.selectedStrengths || [],
                        otherStrengthsText: existingData.otherStrengthsText || "",
                        clientStrengthsDescription: existingData.clientStrengthsDescription || "",
                        primaryDiagnosis: existingData.primaryDiagnosis || "",
                        primaryDiagnosisDescription: existingData.primaryDiagnosisDescription || "",
                        secondaryDiagnosis: existingData.secondaryDiagnosis || "",
                        secondaryDiagnosisDescription: existingData.secondaryDiagnosisDescription || "",
                        tertiaryDiagnosis: existingData.tertiaryDiagnosis || "",
                        tertiaryDiagnosisDescription: existingData.tertiaryDiagnosisDescription || "",
                        clientGoal: existingData.clientGoal || "",
                        objectives: existingData.objectives || "",
                        interventions: existingData.interventions || "",
                        sessionFrequency: existingData.sessionFrequency || "",
                        otherSessionFrequencyText: existingData.otherSessionFrequencyText || "",
                        reviewDate: existingData.reviewDate || "",
                        timeIn: existingData.timeIn || "",
                        timeOut: existingData.timeOut || "",
                        wasClientAtHome: existingData.wasClientAtHome || "",
                        signedAt: existingData.signedAt || null
                    });

                    // Fetch and set addendumData
                    if (existingData.addendumData && Array.isArray(existingData.addendumData)) {
                        setAddendumData(existingData.addendumData);
                    } else {
                        setAddendumData([]);
                    }
                }
            } catch (error) {
                if (error.response?.status !== 404) {
                    console.error("Error fetching session history detail:", error);
                }
            } finally {
                setLoading(false);
            }
        };

        // Only fetch if sessionId is available and no prop data provided
        if (session?._id && !propSessionFormData) {
            fetchSessionHistoryDetail();
        } else if (propSessionFormData) {
            // Use prop data if provided - ensure all fields including wasClientAtHome are included
            setSessionFormData({
                ...propSessionFormData,
                wasClientAtHome: propSessionFormData.wasClientAtHome || "",
                signedAt: propSessionFormData.signedAt || null
            });
            // If addendumData is provided as prop, use it
            if (propAddendumData && Array.isArray(propAddendumData)) {
                setAddendumData(propAddendumData);
            }
        }
    }, [session?._id, user?.user?.token, propSessionFormData, propAddendumData]);
    // Format date function
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
        });
    };

    // Format time function
    const formatDateTime = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
    };

    const clientName = session ? `${session.user?.firstname || ""} ${session.user?.lastname || ""}`.trim() : "";
    const providerName = session ? `${session.health_specialist?.firstname || ""} ${session.health_specialist?.lastname || ""}`.trim() : "";
    const appointmentDate = session?.appointmentdate || session?.appointmenttime;
    const appointmentTime = session?.appointmenttime ? formatDateTime(session.appointmenttime) : "N/A";

    // Format time strings
    const formatTimeString = (timeString) => {
        if (!timeString) return "";
        // If timeString is already in HH:MM format, return as is
        if (timeString.includes(":")) {
            return timeString;
        }
        return timeString;
    };

    // Capitalize first character function
    const capitalizeFirstChar = (str) => {
        if (!str || typeof str !== 'string') return str || "";
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    const toggleSection = (sectionId) => {
        setExpandedSections((prev) => {
            if (prev.includes(sectionId)) {
                return prev.filter((id) => id !== sectionId);
            }
            return [...prev, sectionId];
        });
    };

    const expandSection = (sectionId) => {
        setExpandedSections((prev) => {
            if (prev.includes(sectionId)) {
                return prev;
            }
            return [...prev, sectionId];
        });
    };

    const collapseSection = (sectionId) => {
        setExpandedSections((prev) => prev.filter((id) => id !== sectionId));
    };

    useEffect(() => {
        // Expand all read-only sections by default when viewing initial assessment
        // Also expand all sections when disableToggle is true
        if (readOnlySections && readOnlySections.length > 0) {
            setExpandedSections(readOnlySections.map(({ id }) => id));
        }
    }, [session?._id, disableToggle]);

    useEffect(() => {
        const handleExternalToggle = (event) => {
            // Ignore toggle events when disableToggle is true
            if (disableToggle) return;
            
            const targetId = event.detail?.sectionId;
            const behavior = event.detail?.behavior || "expand";
            if (!targetId) return;
            if (behavior === "toggle") {
                toggleSection(targetId);
            } else if (behavior === "collapse") {
                collapseSection(targetId);
            } else {
                expandSection(targetId);
            }
        };

        if (typeof window !== "undefined") {
            window.addEventListener(SECTION_TOGGLE_EVENT, handleExternalToggle);
        }

        return () => {
            if (typeof window !== "undefined") {
                window.removeEventListener(SECTION_TOGGLE_EVENT, handleExternalToggle);
            }
        };
    }, [disableToggle]);

    if (loading) {
        return (
            <Card className={styles.card}>
                <div style={{ textAlign: "center", padding: "40px" }}>
                    <p>Loading session data...</p>
                </div>
            </Card>
        );
    }

    const readOnlySections = [
        {
            id: "appointment-details",
            title: "Appointment Details",
            content: (
                <>
                    <div className={styles.twoColumnLayout}>
                        <div className={styles.column}>
                            <div className={styles.fieldRow}>
                                <label className={styles.label}>Client</label>
                                <span className={styles.valueSpan} style={{ backgroundColor: "transparent" }}>
                                    {clientName}
                                </span>
                            </div>
                            <div className={styles.fieldRow}>
                                <label className={styles.label}>Date</label>
                                <span className={styles.valueSpan} style={{ backgroundColor: "transparent" }}>
                                    {formatDate(appointmentDate)}
                                </span>
                            </div>
                            <div className={styles.fieldRow}>
                                <label className={styles.label}>Time In</label>
                                <span className={styles.valueSpanMinWidth} style={{ backgroundColor: "transparent", color: "black", fontWeight: "500" }}>
                                    {formatTimeString(sessionFormData?.timeIn) || "N/A"}
                                </span>
                            </div>
                            <div className={styles.fieldRow}>
                                <label className={styles.label}>Duration</label>
                                <span className={styles.valueSpan} style={{ backgroundColor: "transparent" }}>
                                    {sessionFormData?.totalDuration ? `${sessionFormData?.totalDuration}m` : ""}
                                </span>
                            </div>
                        </div>
                        <div className={styles.column}>
                            <div className={styles.fieldRow}>
                                <label className={styles.label}>Provider</label>
                                <span className={styles.valueSpan} style={{ backgroundColor: "transparent" }}>
                                    {providerName}
                                </span>
                            </div>
                            <div className={styles.fieldRow}>
                                <label className={styles.label}>Scheduled Time</label>
                                <span className={styles.valueSpan} style={{ backgroundColor: "transparent" }}>
                                    {appointmentTime}
                                </span>
                            </div>
                            <div className={styles.fieldRow}>
                                <label className={styles.label}>Time Out</label>
                                <span className={styles.valueSpanMinWidth} style={{ backgroundColor: "transparent", color: "black", fontWeight: "500" }}>
                                    {formatTimeString(sessionFormData?.timeOut) || "N/A"}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className={styles.separator}></div>
                    <div className={styles.fieldRowVertical} style={{ flexDirection: "row", paddingBottom: "20px", alignItems: "center" }}>
                        <label className={styles.labelMinWidth} style={{ marginBottom: "0px" }}>
                            Was the client at home?
                        </label>
                        <span className={styles.valueSpan1} style={{ backgroundColor: "transparent", color: "black", fontWeight: "400", textAlign: "left" }}>
                            {sessionFormData?.wasClientAtHome ? capitalizeFirstChar(sessionFormData.wasClientAtHome) : "N/A"}
                        </span>
                    </div>
                </>
            )
        },
        {
            id: "presenting-concerns",
            title: "Presenting Concerns",
            content: (
                <>
                    <div>
                        <label className={styles.labelWithMargin}>Reason for seeking services:</label>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", padding: "12px", borderRadius: "4px", backgroundColor: "transparent", minHeight: "60px", lineHeight: "1.5", textAlign: "left" }}>
                            {sessionFormData?.reasonForSeekingServices || "N/A"}
                        </div>
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                        {sessionFormData?.selectedConcerns && sessionFormData.selectedConcerns.length > 0 ? (
                            <ul style={{ listStyle: "disc", paddingLeft: "32px", margin: "0", fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                                {sessionFormData.selectedConcerns.map((concern, index) => (
                                    <li key={index} style={{ marginBottom: "8px" }}>
                                        {concern}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div style={{ fontSize: "16px", fontWeight: "400", color: "#000" }} />
                        )}
                    </div>
                </>
            )
        },
        {
            id: "history-concerns",
            title: "History of Presenting Concerns",
            content: (
                <>
                    <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginBottom: "16px" }}>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Duration:</span> {sessionFormData?.duration || ""}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Frequency:</span> {sessionFormData?.frequency || ""}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Severity:</span> {sessionFormData?.severity || ""}
                        </div>
                    </div>
                    <div style={{ textAlign: "left", marginBottom: "16px" }}>
                        <div style={{ fontSize: "16px", fontWeight: "500", color: "#000" }}>Notes on history, past interventions</div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", padding: "12px", borderRadius: "4px", backgroundColor: "transparent", minHeight: "60px", lineHeight: "1.5", textAlign: "left" }}>
                            {sessionFormData?.freeTextHistory || ""}
                        </div>
                    </div>
                </>
            )
        },
        {
            id: "medical-psychiatric",
            title: "Medical & Psychiatric History",
            content: (
                <>
                    <div style={{ textAlign: "left", marginBottom: "8px" }}>
                        <div style={{ fontSize: "16px", fontWeight: "500", marginBottom: "8px", color: "#000" }}>Medical Conditions</div>
                        {sessionFormData?.selectedMedicalConditions?.length > 0 ? (
                            <ul style={{ listStyle: "disc", paddingLeft: "32px", margin: "0", fontSize: "16px", fontWeight: "400", color: "#000" }}>
                                {sessionFormData.selectedMedicalConditions.map((treatment, index) => (
                                    <li key={index} style={{ marginBottom: "8px" }}>
                                        {treatment}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div style={{ fontSize: "16px", fontWeight: "400", color: "#000" }} />
                        )}
                        {sessionFormData?.selectedMedicalConditions?.includes("Other") && (
                            <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", padding: "12px", borderRadius: "4px", backgroundColor: "transparent", minHeight: "60px", lineHeight: "1.5", textAlign: "left" }}>
                                {sessionFormData?.otherMedicalConditionText}
                            </div>
                        )}
                    </div>
                    <div style={{ textAlign: "left", marginBottom: "8px" }}>
                        <div style={{ fontSize: "16px", fontWeight: "500", color: "#000", marginBottom: "4px" }}>Current Medications</div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", padding: "12px", borderRadius: "4px", backgroundColor: "transparent", minHeight: "60px", lineHeight: "1.5", textAlign: "left" }}>
                            {sessionFormData?.currentMedications || "N/A"}
                        </div>
                    </div>
                    <div style={{ textAlign: "left", paddingBottom: "20px" }}>
                        <div style={{ fontSize: "16px", fontWeight: "500", color: "#000", marginBottom: "8px" }}>Prior Psychiatric Care</div>
                        {sessionFormData?.selectedPastPsychiatric?.length > 0 ? (
                            <ul style={{ listStyle: "disc", paddingLeft: "32px", margin: "0", fontSize: "16px", fontWeight: "400", color: "#000" }}>
                                {sessionFormData.selectedPastPsychiatric.map((treatment, index) => (
                                    <li key={index} style={{ marginBottom: "8px" }}>
                                        {treatment}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div style={{ fontSize: "16px", fontWeight: "400", color: "#000" }} />
                        )}
                    </div>
                </>
            )
        },
        {
            id: "substance-use",
            title: "Substance Use",
            content: (
                <>
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "16px" }}>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Alcohol:</span> {sessionFormData?.alcohol || ""}
                        </div>
                        {sessionFormData?.alcoholDetails && sessionFormData.alcoholDetails.trim() !== "" && (
                            <div style={{ marginBottom: "16px" }}>
                                <label className={styles.labelWithMargin}>Details (Frequency, Amount, Impact):</label>
                                <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", padding: "12px", borderRadius: "4px", backgroundColor: "transparent", minHeight: "60px", lineHeight: "1.5", textAlign: "left" }}>
                                    {sessionFormData.alcoholDetails}
                                </div>
                            </div>
                        )}
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Cannabis:</span> {sessionFormData?.cannabis || ""}
                        </div>
                        {sessionFormData?.cannabisDetails && sessionFormData.cannabisDetails.trim() !== "" && (
                            <div style={{ marginBottom: "16px" }}>
                                <label className={styles.labelWithMargin}>Details (Frequency, Amount, Impact):</label>
                                <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", padding: "12px", borderRadius: "4px", backgroundColor: "transparent", minHeight: "60px", lineHeight: "1.5", textAlign: "left" }}>
                                    {sessionFormData?.cannabisDetails || "N/A"}
                                </div>
                            </div>
                        )}
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Tobacco:</span> {sessionFormData?.tobacco || ""}
                        </div>
                        {sessionFormData?.tobaccoDetails && sessionFormData.tobaccoDetails.trim() !== "" && (
                            <div style={{ marginBottom: "16px" }}>
                                <label className={styles.labelWithMargin}>Details (Frequency, Amount, Impact):</label>
                                <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", padding: "12px", borderRadius: "4px", backgroundColor: "transparent", minHeight: "60px", lineHeight: "1.5", textAlign: "left" }}>
                                    {sessionFormData?.tobaccoDetails || "N/A"}
                                </div>
                            </div>
                        )}
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Illicit Drugs:</span> {sessionFormData?.illicitDrugs || ""}
                        </div>
                        {sessionFormData?.illicitDrugsDetails && sessionFormData.illicitDrugsDetails.trim() !== "" && (
                            <div style={{ marginBottom: "16px" }}>
                                <label className={styles.labelWithMargin}>Details (Frequency, Amount, Impact):</label>
                                <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", padding: "12px", borderRadius: "4px", backgroundColor: "transparent", minHeight: "60px", lineHeight: "1.5", textAlign: "left" }}>
                                    {sessionFormData?.illicitDrugsDetails || "N/A"}
                                </div>
                            </div>
                        )}
                    </div>

                </>
            )
        },
        {
            id: "family-social",
            title: "Family & Social History",
            content: (
                <>
                    <div style={{ display: "flex", flexDirection: "row", gap: "12px" }}>
                        <label className={styles.labelWithMarginLarge} style={{ marginBottom: "0px" }}>
                            Living Situation:
                        </label>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", borderRadius: "4px", backgroundColor: "transparent", minHeight: "40px", lineHeight: "1.5", textAlign: "left" }}>
                            {sessionFormData?.livingSituation || "N/A"}
                        </div>
                    </div>
                    <div style={{ marginBottom: "24px" }}>
                        <label className={styles.labelWithMarginLarge}>Support System:</label>
                        {sessionFormData?.selectedSupportSystem?.length > 0 ? (
                            <ul style={{ listStyle: "disc", paddingLeft: "32px", margin: "0", fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                                {sessionFormData.selectedSupportSystem.map((support, index) => (
                                    <li key={index} style={{ marginBottom: "8px" }}>
                                        {support}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div style={{ fontSize: "16px", fontWeight: "400", color: "#000" }} />
                        )}
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                        <label className={styles.labelWithMargin}>Additional Notes:</label>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", padding: "12px", borderRadius: "4px", backgroundColor: "transparent", minHeight: "60px", lineHeight: "1.5", textAlign: "left" }}>
                            {sessionFormData?.familySocialNotes || ""}
                        </div>
                    </div>
                </>
            )
        },
        {
            id: "education-occupation",
            title: "Education & Occupation",
            content: (
                <>
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "16px" }}>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left", paddingBottom: "8px" }}>
                            <span style={{ fontWeight: "500" }}>Highest Education Level:</span> {sessionFormData?.highestEducationLevel || ""}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left", paddingBottom: "8px" }}>
                            <span style={{ fontWeight: "500" }}>Employment Status:</span> {sessionFormData?.employmentStatus || ""}
                        </div>
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                        <label className={styles.labelWithMarginXLarge} style={{ marginBottom: "8px" }}>
                            Current job/role:
                        </label>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", padding: "12px", borderRadius: "4px", backgroundColor: "transparent", minHeight: "60px", lineHeight: "1.5", textAlign: "left" }}>
                            {sessionFormData?.currentJobRole || ""}
                        </div>
                    </div>
                </>
            )
        },
        {
            id: "mental-status",
            title: "Mental Status Exam",
            content: (
                <>
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "32px" }}>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Appearance:</span> {sessionFormData?.appearance || ""}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Behavior:</span> {sessionFormData?.behavior || ""}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Speech:</span> {sessionFormData?.speech || ""}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Mood:</span> {sessionFormData?.mood || ""}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Affect:</span> {sessionFormData?.affect || ""}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Thought Process:</span> {sessionFormData?.thoughtProcess || ""}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Orientation:</span> {sessionFormData?.orientation || ""}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Insight/Judgment:</span> {sessionFormData?.insightJudgment || ""}
                        </div>
                    </div>
                </>
            )
        },
        {
            id: "risk-safety",
            title: "Risk & Safety",
            content: (
                <>
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "32px" }}>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Suicide Risk:</span> {sessionFormData?.suicideRisk || ""}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Homicide Risk:</span> {sessionFormData?.homicideRisk || ""}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Abuse/Neglect:</span> {sessionFormData?.abuseNeglect || ""}
                        </div>
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                        <label className={styles.labelWithMarginXLarge} style={{ marginBottom: "8px" }}>
                            Safety Plan Notes:
                        </label>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", padding: "12px", borderRadius: "4px", backgroundColor: "transparent", minHeight: "60px", lineHeight: "1.5", textAlign: "left" }}>
                            {sessionFormData?.safetyPlanNotes || ""}
                        </div>
                    </div>
                </>
            )
        },
        {
            id: "strength-resources",
            title: "Strengths & Resources",
            content: (
                <>
                    <div style={{ marginBottom: "24px" }}>
                        <label className={styles.labelWithMarginXLarge}>Select all that apply:</label>
                        {sessionFormData?.selectedStrengths?.length > 0 ? (
                            <ul style={{ listStyle: "disc", paddingLeft: "32px", margin: "0", fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                                {sessionFormData.selectedStrengths.map((strength, index) => (
                                    <li key={index} style={{ marginBottom: "8px", textAlign: "left" }}>
                                        {strength}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div style={{ fontSize: "16px", fontWeight: "400", color: "#000" }} />
                        )}
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                        <label className={styles.labelWithMarginXLarge} style={{ marginBottom: "8px" }}>
                            Client's own description of strengths:
                        </label>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", padding: "12px", borderRadius: "4px", backgroundColor: "transparent", minHeight: "60px", lineHeight: "1.5", textAlign: "left" }}>
                            {sessionFormData?.clientStrengthsDescription || ""}
                        </div>
                    </div>
                </>
            )
        },
        {
            id: "diagnosis",
            title: "Diagnosis",
            content: (
                <>
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "32px" }}>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Primary Diagnosis:</span> {sessionFormData?.primaryDiagnosis || ""} {sessionFormData?.primaryDiagnosisDescription || ""}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Secondary Diagnosis:</span> {sessionFormData?.secondaryDiagnosis || ""} {sessionFormData?.secondaryDiagnosisDescription || ""}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", textAlign: "left" }}>
                            <span style={{ fontWeight: "500" }}>Tertiary Diagnosis:</span> {sessionFormData?.tertiaryDiagnosis || ""} {sessionFormData?.tertiaryDiagnosisDescription || ""}
                        </div>
                    </div>
                </>
            )
        },
        {
            id: "care-plan",
            title: "Care Plan",
            content: (
                <>
                    <div style={{ marginBottom: "16px" }}>
                        <label className={styles.labelWithMarginXLarge} style={{ marginBottom: "8px" }}>
                            Client Goal:
                        </label>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", padding: "12px", borderRadius: "4px", minHeight: "60px", lineHeight: "1.5", textAlign: "left" }}>
                            {sessionFormData?.clientGoal || ""}
                        </div>
                    </div>
                    <div style={{ marginBottom: "16px" }}>
                        <label className={styles.labelWithMarginXLarge} style={{ marginBottom: "8px" }}>
                            Objectives:
                        </label>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", padding: "12px", borderRadius: "4px", minHeight: "60px", lineHeight: "1.5", textAlign: "left" }}>
                            {sessionFormData?.objectives || ""}
                        </div>
                    </div>
                    <div style={{ marginBottom: "16px" }}>
                        <label className={styles.labelWithMarginXLarge} style={{ marginBottom: "8px" }}>
                            Interventions:
                        </label>
                        <div style={{ fontSize: "16px", fontWeight: "400", color: "#000", padding: "12px", borderRadius: "4px", minHeight: "60px", lineHeight: "1.5", textAlign: "left" }}>
                            {sessionFormData?.interventions || ""}
                        </div>
                    </div>
                    <div style={{ marginBottom: "16px", display: "flex", flexDirection: "row", gap: "12px", alignItems: "center" }}>
                        <label className={styles.labelWithMarginXLarge} style={{ marginBottom: "0px" }}>
                            Session Frequency:
                        </label>
                        <span className={styles.valueSpan1} style={{ backgroundColor: "transparent", color: "black", fontWeight: "400", textAlign: "left", padding: "0px" }}>
                            {sessionFormData?.sessionFrequency || ""}
                        </span>
                    </div>
                </>
            )
        },
    ];

    return (
        <>
            <Card className={styles.card}>
                <div className={styles.collapsibleStack}>
                    {readOnlySections.map(({ id, title, content }) => {
                        const isExpanded = disableToggle ? true : expandedSections.includes(id);
                        return (
                            <div id={id} key={id} className={styles.collapsibleSection}>
                                {disableToggle ? (
                                    <div
                                        className={styles.collapsibleHeader}
                                        style={{ cursor: 'default', pointerEvents: 'none' }}
                                    >
                                        <span>{title}</span>
                                    </div>
                                ) : (
                                    <button
                                        type="button"
                                        className={styles.collapsibleHeader}
                                        onClick={() => toggleSection(id)}
                                        aria-expanded={isExpanded}
                                        aria-controls={`${id}-content`}
                                    >
                                        <span>{title}</span>
                                    </button>
                                )}
                                <div
                                    id={`${id}-content`}
                                    className={isExpanded ? styles.collapsibleBodyExpanded : styles.collapsibleBodyCollapsed}
                                >
                                    {content}
                                    {isExpanded && <div className={styles.collapsibleSeparator} />}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </Card>

            {/* Render Addendum Cards */}
            {addendumData && Array.isArray(addendumData) && addendumData.length > 0 && (
                <>
                    {addendumData.map((addendum, index) => {
                        // Only show addendums that have addendumText
                        if (!addendum.addendumText || addendum.addendumText.trim() === "") {
                            return null;
                        }

                        const addendumNumber = index + 1;
                        return (
                            <Card key={`addendum-${index}`} className={styles.card}>
                                <div className={styles.collapsibleStack}>
                                    <div className={styles.collapsibleSection}>
                                        <div style={{ paddingTop: "20px" }}>
                                            <h3 className={styles.sectionHeading} style={{ marginBottom: "16px", fontSize: "20px", fontWeight: "600" }}>
                                                Addendum # {addendumNumber}
                                            </h3>
                                            <div style={{ marginBottom: "16px" }}>
                                                <label className={styles.labelWithMarginXLarge} style={{ marginBottom: "8px" }}>
                                                    Provide addendum or correction details:
                                                </label>
                                                <div style={{
                                                    fontSize: "16px",
                                                    fontWeight: "400",
                                                    color: "#000",
                                                    padding: "12px",
                                                    borderRadius: "4px",
                                                    backgroundColor: "transparent",
                                                    minHeight: "60px",
                                                    lineHeight: "1.5",
                                                    textAlign: "left",
                                                    whiteSpace: "pre-wrap",
                                                    wordWrap: "break-word"
                                                }}>
                                                    {addendum.addendumText || ""}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        );
                    })}
                </>
            )}
        </>
    );
};

export default SessionDetailedViewPage;
